window.MobileDetect = require('mobile-detect');

require('./news');
require('../../lib/game-icons');
require('../../lib/game-demo');

